import { getItem, setItem } from "../utils/localStorageUtils";

// Route configuration constants and utilities
export const PORTALS = {
  WF: "wf",
  ATS: "ats",
  PTL: "ptl",
  BS: "bs",
  NM: "nm",
};

// Common routes configuration
// These routes are accessible across all portals
export const COMMON_ROUTES = {
  COMPONENTS_LIST: "/components-list",
  SETTINGS: "/settings",
  // Add more common routes here as needed
  // PROFILE: '/profile',
};

export const USER_ROLES = {
  ADMIN: "ADMIN",
  HR: "HR",
  FINANCE: "FINANCE",
  EMPLOYEE: "EMPLOYEE",
  IMMIGRATION: "IMMIGRATION",
};

// Default route configuration based on portal and user role
export const getDefaultRoute = (portal, roleName) => {
  switch (portal) {
    case PORTALS.ATS:
      return "/ats/dashboard";
    case PORTALS.BS:
      return "/bs/dashboard";
    case PORTALS.PTL:
      return "/ptl/dashboard";
    case PORTALS.NM:
      return "/nm/dashboard";
    case PORTALS.WF:
    default:
      return roleName !== "EMPLOYEE" ? "/dashboard" : "/timesheet";
  }
};

/**
 * Check if a route is a common route that should be available across all portals
 * @param {string} pathname - The route pathname to check
 * @returns {boolean} True if the route is common across portals
 */
export const isCommonRoute = (pathname) => {
  return Object.values(COMMON_ROUTES).some((route) =>
    pathname.startsWith(route),
  );
};

/**
 * Get portal-specific routes configuration
 * This helps in determining which routes belong to which portal
 */
export const PORTAL_ROUTES = {
  [PORTALS.WF]: {
    dashboard: "/dashboard",
    employees: "/employee",
    clients: "/client",
    vendors: "/vendor",
    timesheets: "/timesheet",
    // Add more WF-specific routes
  },
  [PORTALS.ATS]: {
    dashboard: "/ats-dashboard",
    // Add more ATS-specific routes
  },
  [PORTALS.BS]: {
    dashboard: "/bs-dashboard",
    // Add more ATS-specific routes
  },
  [PORTALS.PTL]: {
    dashboard: "/ptl-dashboard",
    // Add more PTL-specific routes
  },
  [PORTALS.NM]: {
    dashboard: "/nm-dashboard",
    // Add more PTL-specific routes
  },
};

// Portal initialization utility
export const initializePortal = () => {
  // const portal = localStorage.getItem("portal");
  const portal = getItem("portal");
  const initialValue = portal || PORTALS.WF;

  if (!portal) {
    // localStorage.setItem("portal", PORTALS.WF);
    setItem("portal", PORTALS.WF); // save module
  }

  return initialValue;
};
